// extracted by css-extract-rspack-plugin
export default {"bubble":"Bubble_bubble__TAKkk"};